import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import InputRow from '../../../Components/InputRow';
import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';

import AppColor from '../../../AppColor';
import TravelerHelper from '../../../Helper/Traveler';

export default class FITItemTicket extends React.Component {
	onAirlineChange = value => {
		this.props.onChange('selectedAirline', value);
	};

	removeRow = index => {
		this.props.onRemove(index);
	};

	passengerTravelerId = p => {
		if (!p) return null;
		if (p.travelerId != null && p.travelerId !== '') return Number(p.travelerId);
		if (p.traveler && p.traveler.id != null) return Number(p.traveler.id);
		return null;
	};

	isTravelerIdUsedByOtherPassenger = (travelerId, excludeIndex) => {
		const list = (this.props.fitTicket && this.props.fitTicket.passengers) || this.props.passengers;
		if (!list || travelerId == null) return false;
		const id = Number(travelerId);
		if (Number.isNaN(id)) return false;
		return list.some((p, i) => {
			if (i === excludeIndex) return false;
			const pid = this.passengerTravelerId(p);
			return pid != null && !Number.isNaN(pid) && pid === id;
		});
	};

	constructor(props) {
		super(props);
		const { initTravelers } = props;
		let travelers = [];
		if (initTravelers && initTravelers.length > 0) {
			for (const traveler of initTravelers) {
				travelers.push({
					value: traveler.id,
					label: TravelerHelper.getNameAndContact(traveler),
				});
			}
		}
		this.state = {
			// Each passenger row has its own options list so search in one row does not affect others.
			_travelerOptionsByRow: {},
			_initialTravelerOptions: travelers,
			_travelerSearchLoadingByRow: {},
		};
	}

	getTravelerOptionsForRow = index =>
		this.state._travelerOptionsByRow[index] != null ? this.state._travelerOptionsByRow[index] : this.state._initialTravelerOptions;

	searchTravelerOptions = async (rowIndex, inputValue) => {
		const name = (inputValue || '').trim();
		if (!name) {
			this.setState(prev => ({
				_travelerOptionsByRow: {
					...prev._travelerOptionsByRow,
					[rowIndex]: prev._initialTravelerOptions,
				},
				_travelerSearchLoadingByRow: {
					...prev._travelerSearchLoadingByRow,
					[rowIndex]: false,
				},
			}));
			return;
		}

		this.setState(prev => ({
			_travelerSearchLoadingByRow: {
				...prev._travelerSearchLoadingByRow,
				[rowIndex]: true,
			},
		}));
		const request = await APIGet('travelers?page=1&perPage=40&filter=' + name);
		if (APIHelper.handleAPIResponse(this, request)) {
			const responseData = request.data;
			const travelerData = Array.isArray(responseData) ? responseData : responseData.data || [];
			this.setState(prev => ({
				_travelerOptionsByRow: {
					...prev._travelerOptionsByRow,
					[rowIndex]: travelerData.map(traveler => ({
						value: traveler.id,
						label: TravelerHelper.getNameAndContact(traveler),
					})),
				},
				_travelerSearchLoadingByRow: {
					...prev._travelerSearchLoadingByRow,
					[rowIndex]: false,
				},
			}));
		} else {
			this.setState(prev => ({
				_travelerSearchLoadingByRow: {
					...prev._travelerSearchLoadingByRow,
					[rowIndex]: false,
				},
			}));
			toast.error('ไม่สามารถค้นหา Traveler ได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	handleTravelerInputChange = (rowIndex, inputValue, actionMeta) => {
		// Only trigger search when user types into the input.
		if (actionMeta && actionMeta.action && actionMeta.action !== 'input-change') return inputValue;
		this.searchTravelerOptions(rowIndex, inputValue);
		return inputValue;
	};

	renderSelectOrInputTraveler = (passenger, index) => {
		const travelerOptions = this.getTravelerOptionsForRow(index);
		let displayValue = null;
		// console.log('passenger: ', passenger);
		// console.log('travelerOptions: ', travelerOptions);
		const travelerId = this.passengerTravelerId(passenger);
		if (travelerOptions && travelerOptions.length > 0) {
			const fromOptions = travelerId != null ? travelerOptions.find(option => Number(option.value) === Number(travelerId)) : null;
			// console.log('fromOptions: ', fromOptions);
			if (fromOptions) {
				displayValue = { value: fromOptions.value, label: fromOptions.label };
			} else if (passenger.traveler && passenger.traveler.id != null) {
				displayValue = {
					value: passenger.traveler.id,
					label: TravelerHelper.getFullName(passenger.traveler),
				};
			} else if (typeof passenger.name === 'string' && passenger.name.trim() !== '') {
				displayValue = { value: null, label: passenger.name };
			}
		} else if (typeof passenger.name === 'string' && passenger.name.trim() !== '') {
			// console.log('passenger.name: ', passenger.name);
			displayValue = { value: null, label: passenger.name };
		}

		return (
			<>
				<CreatableSelect
					isClearable
					placeholder="พิมพ์ค้นหาหรือใส่ชื่อผู้โดยสาร"
					// formatOptionLabel={option => <span style={TravelerHelper.fullNameStyle}>{option.label}</span>}
					value={displayValue}
					onInputChange={(inputValue, actionMeta) => this.handleTravelerInputChange(index, inputValue, actionMeta)}
					onChange={option => {
						if (option) {
							const numericId = Number(option.value);
							const isRegisteredTravelerId = Number.isInteger(numericId) && !Number.isNaN(numericId);
							if (isRegisteredTravelerId) {
								if (this.isTravelerIdUsedByOtherPassenger(numericId, index)) {
									toast.warn('Traveler นี้ถูกเพิ่มไปแล้ว');
									return;
								}
								// Ensure any old traveler object is cleared so the UI resets correctly.
								this.props.onPassengerChange(index, 'traveler', null);
								this.props.onPassengerChange(index, 'travelerId', numericId);
							} else {
								// Custom name (typed / creatable option)
								this.props.onPassengerChange(index, 'traveler', null);
								this.props.onPassengerChange(index, 'travelerId', null);
							}

							this.props.onPassengerChange(index, 'name', option.label);
						} else {
							// Clear (x mark)
							this.props.onPassengerChange(index, 'traveler', null);
							this.props.onPassengerChange(index, 'travelerId', null);
							this.props.onPassengerChange(index, 'name', null);
						}
					}}
					options={travelerOptions}
					isLoading={!!this.state._travelerSearchLoadingByRow[index]}
					formatCreateLabel={inputValue => 'ใช้ชื่อ "' + inputValue + '"'}
					noOptionsMessage={() => 'พิมพ์เพื่อเพิ่มชื่อใหม่'}
				/>
			</>
		);
	};

	renderRow = () => {
		const { passengers } = this.props;
		if (!passengers) return null;
		return passengers.map((passenger, index) => (
			<div className="row columns" key={'fitTIcketPassenger' + index}>
				<div className="column is-4">
					<label className="label">{'ชื่อผู้โดยสาร ' + (index + 1)}</label>
					{this.renderSelectOrInputTraveler(passenger, index)}
				</div>
				<div className="column is-3">
					<InputRow
						title={'หมายเลขตั๋ว ' + (index + 1)}
						labelSize="s"
						placeholder="หมายเลขตั๋ว"
						keyProps="ticketNumber"
						value={passenger.ticketNumber}
						onInputChange={(key, value) => this.props.onPassengerChange(index, key, value)}
						disabled={false}
					/>
				</div>
				<div className="column is-2">
					<InputRow
						title="ราคาขาย (THB)"
						labelSize="s"
						placeholder="ราคาขาย (THB)"
						keyProps="salePrice"
						type="number"
						value={passenger.salePrice}
						onInputChange={(key, value) => this.props.onPassengerChange(index, key, value)}
						disabled={false}
					/>
				</div>
				<div className="column is-2">
					<InputRow
						title="ต้นทุน (THB)"
						labelSize="s"
						placeholder="ต้นทุน (THB)"
						keyProps="price"
						type="number"
						value={passenger.price}
						onInputChange={(key, value) => this.props.onPassengerChange(index, key, value)}
						disabled={false}
					/>
				</div>
				<div className="column is-1" style={{ paddingTop: 50, textAlign: 'center' }}>
					<a onClick={() => this.removeRow(index)}>
						<h4 className="title is-4" style={{ color: 'red' }}>
							<FontAwesomeIcon icon="minus-circle" />
						</h4>
					</a>
				</div>
			</div>
		));
	};

	render() {
		const { route, selectedAirline, flightNumber, pnr, airlines } = this.props;
		return (
			<div className="row">
				<div className="row columns" style={{ backgroundColor: '#eeeeee' }}>
					<div className="column is-3">
						<label className="label">Airline</label>
						<Select name="fitType" value={selectedAirline} clearable={false} onChange={this.onAirlineChange} options={airlines} />
					</div>
					<div className="column is-3">
						<InputRow
							title="Route"
							labelSize="s"
							placeholder="Route"
							keyProps="route"
							value={route}
							onInputChange={this.props.onChange}
							disabled={false}
						/>
					</div>
					<div className="column is-3">
						<InputRow
							title="Flight Number"
							labelSize="s"
							placeholder="Flight Number"
							keyProps="flightNumber"
							value={flightNumber}
							onInputChange={this.props.onChange}
							disabled={false}
						/>
					</div>
					<div className="column is-3">
						<InputRow title="PNR" labelSize="s" placeholder="PNR" keyProps="pnr" value={pnr} onInputChange={this.props.onChange} disabled={false} />
					</div>
				</div>
				{this.renderRow()}
				<div
					className="row box clickable"
					style={{ backgroundColor: AppColor.bulma.isPrimary, textAlign: 'center', padding: 8, color: 'white' }}
					onClick={this.props.onAdd}
				>
					เพิ่มรายการย่อย
				</div>
			</div>
		);
	}
}
